<template>
  <div>
    <el-row class="search-title common-table-top" style="margin-top: 20px;padding-right: 0">
      <el-col :span="4" style="text-align: left;">
        <i class="el-icon-document" style="font-weight: bold;"></i>
        <span class="order-list-search-span">客户列表</span>
      </el-col>
      <el-col :span="20" class="text-align-right">
        <el-button type="primary" class="add-btn" style="margin-right: 32px" @click="downloads">导出</el-button>
      </el-col>
    </el-row>
    <el-row class="import-data-title">
      <el-table
        :data="tableData"
        style="">
        <el-table-column
          prop="realname"
          label="客户">
          <template slot-scope="scope">
            <img :src="scope.row.avatar" alt="" style="width: 40px;display: block;margin: 0 auto;border-radius: 50%;float:left;margin-right:10px;">
            <div style="line-height: 32px;">{{ scope.row.realname }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="mobile"
          label="手机号">
        </el-table-column>
        <el-table-column
          prop="activity_name"
          label="活动类型">
        </el-table-column>
        <el-table-column
          prop="systemPcd"
          label="地区">
        </el-table-column>
        <el-table-column
          prop=""
          label="扫码时间">
          <template slot-scope="scope">
            {{ scope.row.create_time }}
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <div class="table-foot" style="text-align: right">
      <el-pagination
        class="table-foot-pagination"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-size="limit"
        layout="total, prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { exportFieldTotal, keywordApi, delKeywordApi, getFiledTotal } from '@/api/customer.js'
export default {
  name: 'fieldTotal',
  data () {
    return {
      tableData: [],
      publicNumber: [],
      original_id: '',
      public_id: '',
      total: 0,
      page: 1,
      limit: 10
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData() {
      let id = this.$route.query.id
      getFiledTotal(id, this.limit, this.page).then((res) => {
        if (res.data.code === 0) {
          this.tableData = res.data.data.list
          this.total = res.data.data.total
        } else {
          _g.toastMsg('error', res.data.error)
        }
      })
    },
    // 处理分页
    handleCurrentChange(val) {
      console.log(val)
      this.page = val
      this.getData()
    },
    // 处理分页
    handleSizeChange(val) {
      this.limit = val
      this.getData()
    },
    // 导出
    downloads() {
      if (this.total === 0) {
        _g.toastMsg('error', '没有数据可导出')
        return
      }
      let id = this.$route.query.id
      exportFieldTotal(id).then(response => {
        this.download(response)
      }).catch((error) => {
        console.log(error)
        _g.toastMsg('error', error)
      })
    },
    // 下载文件
    download (data) {
      if (!data) {
        return
      }
      var now = new Date()
      var year = now.getFullYear()
      var month = (now.getMonth() + 1 < 10 ? '0' + (now.getMonth() + 1) : (now.getMonth()) + 1)
      console.log(month)
      var date = now.getDate()
      var hour = now.getHours()
      var minute = now.getMinutes()
      var second = now.getSeconds()
      let time = ''
      time = year + '' + month + '' + date + '' + hour + '' + minute + '' + second
      var blob = new Blob([data.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8' }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
      var downloadElement = document.createElement('a')
      var href = window.URL.createObjectURL(blob) // 创建下载的链接
      downloadElement.href = href
      downloadElement.download = time + '.xlsx' // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    }
  },
  created() {
  }
}
</script>

<style scoped>
.sign-manage-title {
  background: #ecf6ff;
  border: 1px solid #E4e4e4;
  height:60px;
  padding:10px;
  line-height: 40px;
  margin-top: 10px;
}
.green {
  color: green;
}
.red {
  color: red;
}
.table-title {
  text-align: left;
}
.dialog-content {
  height: 200px;
}
.content-one span {
  display: inline-block;
  float: left;
  line-height: 20px;
  font-size: 16px;
  margin-top: 10px;
}
.content-one p {
  text-align: left;
}
</style>
